var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-error-viewer"},[_vm._v(" "+_vm._s(_vm.message)+" "),_c('span',{staticClass:"logout__text",on:{"click":function($event){$event.preventDefault();return _vm.$oidc.signOut()}}},[_vm._v(_vm._s(_vm.$t('user.desk.logout')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }